module.exports = __webpack_public_path__ + "static/media/location.15d375b7.svg";